////////
// Investment Map
// ---------------
// @desc 		Function for the investment map
// @param		DOM element
////////
var InvestmentMap = function(domID, payload) {

	this.selectors = {
		block: ".block-investment-map",
		state: ".map-state",
		map: ".map-display"
	};

	this.flags = {
		ACTIVE: "active",
		STATE_PREFIX: "state-"
	};

	// Map variables
	this.accessToken = 'pk.eyJ1IjoiYnJhbmRwaWUiLCJhIjoiY2s4enM1dHpmMWxqMjNwbzdtbzlsZTh1ZyJ9.HCgiFKPaJbIBqrNMnr3EJg';
	this.id = domID;
	this.payload = payload;
	this.map = false;
	this.statesData = [];
	this.activeState = false;

	// DOM captures
	this.element = $(this.selectors.block);
	this.states = this.element.find(this.selectors.state);

	// Click hander
	this.states.on("click", this, function(e) {
		var obj = e.data;
		var stateIndex = Number($(this).attr("data-state-index"));

		if(stateIndex != obj.activeState) {

			// Hide any previous state
			if(obj.activeState !== false) {
				obj.hideState(obj.activeState);
			}

			// Show new state
			obj.showState(stateIndex);

			// Set active state
			obj.activeState = stateIndex;
		}
	});
}


/***
* Show a map state
***/
InvestmentMap.prototype.showState = function(stateIndex) {
	this.toggleState(stateIndex, this.flags.ACTIVE);
}


/***
* Hide a map state
***/
InvestmentMap.prototype.hideState = function(stateIndex) {
	this.toggleState(stateIndex, "inactive");
}


/***
* Toggle map state
***/
InvestmentMap.prototype.toggleState = function(stateIndex, toggleState) {
	var stateMapData = this.statesData[stateIndex];
	var stateDOM = this.states.eq(stateIndex);

	// If valid request
	if(stateMapData && stateDOM) {

		// Toggle state
		if(toggleState == this.flags.ACTIVE) {
			stateDOM.addClass(this.flags.ACTIVE);
		} else {
			stateDOM.removeClass(this.flags.ACTIVE);
		}

		// Check if there are markers
		if(stateMapData.markers.length) {
			for(var i = 0; i<stateMapData.markers.length; i++) {
				var marker = $(stateMapData.markers[i]._element);
				if(toggleState == this.flags.ACTIVE) {
					marker.css("opacity", 1);
				} else {
					marker.css("opacity", 0);
				}
			}
		}

		// Check if there's a country layer
		if(stateMapData.countryLayer !== false) {
			var visibility = this.map.getLayoutProperty(stateMapData.countryLayer.id, 'visibility');
			if(toggleState == this.flags.ACTIVE && visibility !== 'visible') {
				this.map.setLayoutProperty(stateMapData.countryLayer.id, 'visibility', 'visible');
			} else if(toggleState !== this.flags.ACTIVE && visibility == 'visible') {
				this.map.setLayoutProperty(stateMapData.countryLayer.id, 'visibility', 'none');
			}
		}

	}
}

/***
* Add states data
***/
InvestmentMap.prototype.addStatesData = function() {

	// Marker collection
	this.statesData = [];

	// Check for data payload
	if(this.payload) {

		// Loop through. Each item is a "state"
		for (var i = 0; i < this.payload.length; i++) {

			// New collection based on index
			this.statesData[i] = {
				markers: [],
				countryLayer: false
			};

			// Add markers
			var state = this.payload[i];
			if(state.points && state.points.length) {

				// Add points
				for (var a = 0; a < state.points.length; a++) {
					var point = state.points[a];

					// Generate markers into collection
					var marker = this.addMarker(point.lat, point.lng);
					$(marker._element).css("opacity", 0);
					this.statesData[i].markers.push(marker);
				}
			}

			// Add countries within one country layer
			if(state.countries && state.countries.length) {
			var countries = [];
				for (var b = 0; b < state.countries.length; b++) {
					countries.push(state.countries[b].code);
				}
				this.statesData[i].countryLayer = this.addCountryLayer(this.flags.STATE_PREFIX + b, countries, '#ED5436');
			}

		}
	}
}


/***
* Callback for the map loader
***/
InvestmentMap.prototype._mapReady = function() {
	App.log("MapBox loaded", this.map);

	// Add the data to the map
	this.addStatesData();

	// Show default state
	this.showState(0);
	this.activeState = 0;
}


/***
* Add a marker to the map
***/
InvestmentMap.prototype.addMarker = function(lat, lng) {
	var marker = new mapboxgl.Marker({
		color:'#ED5436'
	})
	.setLngLat([lng, lat])
	.addTo(this.map);
	return(marker);
}


/***
* Add a country layer
***/
InvestmentMap.prototype.addCountryLayer = function(id, countries, colour) {
	console.log('Adding layer for countries:', countries); // Debug log

	// Add data
	this.map.addLayer({
		id: id,
		source: {
			type: 'vector',
			url: 'mapbox://brandpie.87bl6peh',
		},
		layout: {
			visibility: 'none'
		},
		'source-layer': 'ne_10m_admin_0_countries_1-68h5hq',
		type: 'fill',
		paint: {
			'fill-color': colour ? colour : '#ED5436',
			'fill-outline-color': colour ? colour : '#ED5436',
		},
	});

	// More comprehensive filter that checks multiple country code fields
	this.map.setFilter(
		id,
		['any',
			['in', ['get', 'ISO_A2'], ['literal', countries]],
			['in', ['get', 'ISO_3166_1_Alpha_2'], ['literal', countries]],
			['in', ['get', 'ISO_A2_EH'], ['literal', countries]],
			['in', ['get', 'ADMIN'], ['literal', countries.map(c => {
				// Map of special cases
				const countryNames = {
					'FR': 'France',
					// Add more mappings as needed
				};
				return countryNames[c] || c;
			})]]
		]
	);

	// Debug: Log available properties for each feature
	this.map.once('sourcedata', () => {
		if (this.map.getSource(id)) {
			console.log('Querying features for layer:', id);
			const features = this.map.querySourceFeatures(id, {
				sourceLayer: 'ne_10m_admin_0_countries_1-68h5hq'
			});
			if (features.length > 0) {
				console.log('Sample feature properties:', features[0].properties);
				features.forEach(feature => {
					if (countries.includes(feature.properties.ISO_A2) || 
						countries.includes(feature.properties.ISO_3166_1_Alpha_2) ||
						feature.properties.ADMIN === 'France') {
						console.log('Found matching country:', feature.properties);
					}
				});
			} else {
				console.log('No features found in source');
			}
		}
	});

	return this.map.getLayer(id);
}


/***
* Render Map
***/
InvestmentMap.prototype.render = function() {
	// Ref: https://dev.to/wuz/building-a-country-highlighting-tool-with-mapbox-2kbh
	// https://studio.mapbox.com/tilesets/brandpie.87bl6peh/
	mapboxgl.accessToken = this.accessToken;

	this.map = new mapboxgl.Map({
		container: this.id,
		continuousWorld: false,
		noWrap: true,
		style: "mapbox://styles/brandpie/ckcywznbb014s1in4oyjgk764",
		zoom: 0,
		center: [150, 0],
		maxBounds: [ [-180, -85], [180, 85] ],
		interactive: false
	});

	// Add callback
	this.map.on('load', this._mapReady.bind(this));
}
